// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { InvoiceHolderFragment } from '../../fragments/generated/invoice-holder.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetInvoiceHolderQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type GetInvoiceHolderQueryResult = { __typename?: 'Query', getInvoiceHolder: { __typename?: 'InvoiceHolderDTO', id: number, fiscalCode: string | null, vatNumber: string | null, fullName: string, name: string | null, surname: string | null, corpName: string | null, address: string | null, city: string | null, cityId: number | null, mail: string | null, mobile: string | null, invoiceHolderType: Types.InvoiceHolderTypeDto, invoiceDocumentType: Types.InvoiceDocumentTypeDto | null } | null };

export const GetInvoiceHolderGql = gql`
    query GetInvoiceHolder($id: Int!) {
  getInvoiceHolder(id: $id) {
    ...InvoiceHolder
  }
}
    ${InvoiceHolderFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetInvoiceHolderInjectable extends Apollo.Query<GetInvoiceHolderQueryResult, GetInvoiceHolderQueryVariables> {
    override document = GetInvoiceHolderGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */